import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { LevelAdvancementRateListService } from '../services/LearningListService';
import LearningReachedLevelRateGauge from './LearningReachedLevelRateGauge';

class LearningReachedLevelRateGaugeContainer extends React.Component {
  constructor(props) {
    super(props);
    LevelAdvancementRateListService.load();
  }

  render() {
    return (
      <LearningReachedLevelRateGauge
        loading={LevelAdvancementRateListService.fetch.fetching}
        value={toJS(LevelAdvancementRateListService.global)}
        formatter={LevelAdvancementRateListService.getFormattedValue}
      />
    );
  }
}

export default observer(LearningReachedLevelRateGaugeContainer);
